// Beden satırındaki atlama-linkini aşağıdaki kılavuza bağlar.
// Manken (<details data-smk>) → aç + kaydır. Modal (size-guide-modal) → tetikleyiciyi tıkla.
(function () {
  function init() {
    var anchor = document.getElementById('beden-kilavuzu');
    var links = document.querySelectorAll('[data-size-guide-jump]');
    if (!anchor || !links.length) return;

    var det = anchor.querySelector('details[data-smk]');
    var modalTrigger = anchor.querySelector('size-guide-modal [data-sg-open]');
    if (!det && !modalTrigger) return; // kılavuz yok → link gizli kalsın

    for (var i = 0; i < links.length; i++) {
      links[i].hidden = false;
      links[i].addEventListener('click', function (e) {
        e.preventDefault();
        if (det) {
          det.open = true;
          anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (modalTrigger) {
          modalTrigger.click();
        } else {
          anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
